export function getItemDisplayTime(item, currentTab) {
    switch (currentTab) {
        case 'recent':
            return item.lastAccessedTime;
        case 'shared':
            return item.lastSharedTime;
        case 'meetings':
            return item.createdDate;
        default:
            return item.lastActionTime;
    }
}
//# sourceMappingURL=getItemDisplayTime.js.map